"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagHK = function FlagHK(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.42,22.52c-8.9.09-18.9-2.76-27.66-12.42a1.6,1.6,0,0,1,.17-2.29h0A1.62,1.62,0,0,1-38.67,8c13.35,14.67,29.9,12.1,39.79,8.56-3.66.16-8.25-.12-11.19-2.06C-22.41,6.37-16.82-2.26-25-12.68S-40.47-22.79-52-21s-15.06-6.64-16.19-11.29a.87.87,0,0,0-1.66-.08C-84.08,6-41.3,53.6,2.63,19.4a48.47,48.47,0,0,1-16,3.12Zm-32-13a.76.76,0,0,1-1.44,0L-48.55,4l-5.64-.19a.76.76,0,0,1-.41-1.39L-50-.77-51.52-6.2A.76.76,0,0,1-50.34-7l4.5,3.41,4.68-3.16A.76.76,0,0,1-40-5.89L-41.86-.55l4.45,3.47a.76.76,0,0,1-.49,1.36l-5.64-.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.09-3c7.07-5.42,16.78-9.13,29.58-6.66a1.62,1.62,0,0,1,1.25,1.94h0A1.61,1.61,0,0,1,47-6.53c-19.47-3.73-31.18,8.25-37,17,2.82-2.33,6.66-4.86,10.19-5.08C35,4.51,35.68,14.76,48.48,18.19S66.91,17,75.1,8.69,91.13,5,94.82,8a.87.87,0,0,0,1.38-.92c-11.67-39.3-74.43-51.71-89.08,2A48.49,48.49,0,0,1,18.09-3Zm33.48-8.79a.76.76,0,0,1,1.18-.83L57.3-9.31l4.63-3.22a.76.76,0,0,1,1.15.87L61.31-6.31l4.5,3.41a.76.76,0,0,1-.46,1.37l-5.64,0L57.85,3.77a.76.76,0,0,1-1.44,0L54.69-1.62l-5.64-.12a.76.76,0,0,1-.43-1.37l4.59-3.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.48.68c-3.47-8.2-4.64-18.53,1-30.3a1.6,1.6,0,0,1,2.18-.72h0a1.62,1.62,0,0,1,.7,2.14c-8.48,17.92.19,32.25,7.23,40C4.05,8.53,2.56,4.18,3.23.71,6-13.78,16.13-11.9,22.66-23.44s3.46-18.14-2.54-28.14S20.53-68,24.4-70.84a.87.87,0,0,0-.56-1.57c-41,1.47-68.67,59.14-20.33,86.74A48.33,48.33,0,0,1-5.48.68Zm-.13-34.61a.75.75,0,0,1-.51-1.34l4.37-3.57-2-5.29A.77.77,0,0,1-2.59-45l4.74,3,4.42-3.5a.76.76,0,0,1,1.21.79L6.34-39.24,11-36.11a.76.76,0,0,1-.38,1.39L5-34.4,3.51-29a.76.76,0,0,1-1.44.07L0-34.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.44,19.28c7.36,5,13.93,13.06,15.6,26a1.6,1.6,0,0,1-1.45,1.79h0a1.6,1.6,0,0,1-1.74-1.41C36.27,26,21.22,18.64,11.08,15.89c3.09,2,6.7,4.81,8,8.09,5.49,13.7-4,17.58-3.26,30.82s6.92,17.13,17.38,22.28,8.56,14,6.83,18.51a.87.87,0,0,0,1.32,1C75,73.19,67.07,9.7,11.48,12.68a48.23,48.23,0,0,1,15,6.6Zm18.85,29a.76.76,0,0,1,1.16.86l-1.74,5.37,4.52,3.38a.76.76,0,0,1-.46,1.37H43.13L41.3,64.62a.76.76,0,0,1-1.44,0l-1.74-5.36-5.64-.09A.76.76,0,0,1,32,57.79l4.56-3.32-1.66-5.39a.76.76,0,0,1,1.17-.84l4.57,3.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,35.24C5.5,43.77-.17,52.48-12,58a1.61,1.61,0,0,1-2.14-.83h0a1.6,1.6,0,0,1,.82-2.09c17.94-8.45,20.36-25,19.89-35.51-.92,3.54-2.54,7.85-5.26,10.1C-10,39.07-16.65,31.2-29,36S-43.23,47.75-45,59.29-55.74,71.71-60.52,71.43A.87.87,0,0,0-61.09,73C-28.54,97.91,29.52,71,9.77,19A48,48,0,0,1,8,35.24ZM-13.88,62a.75.75,0,0,1-.46,1.36l-5.64,0-1.85,5.33a.76.76,0,0,1-1.44,0L-25,63.31l-5.64-.11a.76.76,0,0,1-.43-1.38l4.58-3.3-1.64-5.4a.76.76,0,0,1,1.18-.83l4.54,3.33,4.64-3.22a.76.76,0,0,1,1.15.86l-1.76,5.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagHK;
exports["default"] = _default;